import { ModalController } from './ModalController.js';
// generic
import { AlertModalController } from './Generic/AlertModal/AlertModalController';
import { ConfirmModalController } from './Generic/ConfirmModal/ConfirmModalController.js';
import { LoadingModalController } from './Generic/LoadingModal/LoadingModalController.js';
// authen
import { PdpaModalController } from './Authen/PdpaModal/PdpaModalController.js';
// redeem
import { ConfirmRedeemModalController } from '@/module/Detail/modal/ConfirmRedeemModal/ConfirmRedeemModalController.js';
import { SerialModalController } from '@/module/Detail/modal/SerialModal/SerialModalController.js';
import { DrawDeliveryModalController } from '@/module/Detail/modal/DrawDeliveryModal/DrawDeliveryModalController.js';
import { ShareModalController } from '@/module/Detail/modal/ShareModal/ShareModalController.js';
// address
import { AddAddressModalController } from '@/module/Address/DeliveryAddress/modal/AddAddressModal/AddAddressModalController.js';
import { EditAddressModalController } from '@/module/Address/DeliveryAddress/modal/EditAddressModal/EditAddressModalController.js';
import { ListAddressModalController } from '@/module/Address/DeliveryAddress/modal/ListAddressModal/ListAddressModalController.js';
import { AddTaxAddressModalController } from '@/module/Address/TaxAddress/modal/AddTaxAddressModal/AddTaxAddressModalController.js';
import { EditTaxAddressModalController } from '@/module/Address/TaxAddress/modal/EditTaxAddressModal/EditTaxAddressModalController.js';
import { ListTaxAddressModalController } from '@/module/Address/TaxAddress/modal/ListTaxAddressModal/ListTaxAddressModalController.js';
import { ShippingAddressModalController } from '@/module/Detail/modal/ShippingAddressModal/ShippingAddressModalController.js';
// pdpa
import { CancelTermsAndPrivacyModalController } from '@/module/Static/Pdpa/modal/CancelTermsAndPrivacyModal/CancelTermsAndPrivacyModalController.js';
// profilr
import { ChangeMobileNumberModalController } from '@/module/Profile/modal/ChangeMobileNumber/ChangeMobileNumberModalController.js';

import { FlashsaleModalController } from '../../module/Home/component/modal/FlashsaleModalController';

// Badge
import { BadgeAlertModalController } from '../../module/Badge/modal/BadgeAlertModalController'

//confirmSurprise
import { ConfirmSurpriseModalController } from '@/module/SurpriseBox/modal/ConfirmSurpriseModalController'
import { AlertConditionModalController } from '@/module/SurpriseBox/modal/AlertConditionModalController'

import { FGFModalController } from '@/module/FriendGetFriend/modal/FGFModal/FGFModalController.js';
import { FGFShareModalController } from '@/module/FriendGetFriend/modal/ShareModal/ShareModalController.js';

import { PromocodeModalController } from '@/module/Promocode/modal/PromocodeModal/PromocodeModalController.js';
import { PromocodeSuccessModalController } from '@/module/Promocode/modal/ConfirmModal/PromocodeSuccessModalController.js';

import { VerifyCodeModalController } from '@/module/SurpriseBox/modal/VerifyCodeModal/VerifyCodeModalController.js';

/**
 * @method getModalController
 * generic
 * @method getAlertModal
 * @method getConfirmModal
 * @method getLoadingModal
 * redeem
 * @method getConfirmRedeemModal
 * @method getSerialModal
 * @method getDrawDeliveryModal
 */
export default function ModalFactory() {
    this.modalController = new ModalController();

    //generic
    this.alertModal = null;
    this.confirmModal = null;
    this.loadingModal = null;
    //authen
    this.pdpaModal = null;
    //redeem
    this.confirmRedeemModal = null;
    this.serialModal = null;
    this.drawDeliveryModal = null;
    this.shippingAddressModal = null;
    this.shareModal = null;
    //address
    this.addAddressModal = null;
    this.editAddressModal = null;
    this.listAddressModal = null;
    this.addTaxAddressModal = null;
    this.editTaxAddressModal = null;
    this.listTaxAddressModal = null;
    //pdpa
    this.cancelTermsAndPrivacyModal = null;
    // profile
    this.changeMobileNumberModal = null;
    this.flashSaleModal = null;

    this.badgeAlertModal = null;

    //surprisebox
    this.confirmSurpriseModal = null;
    this.alertConditionModal = null;

    this.fgfModal = null;

    this.promocodeModal = null;
    this.promocodeSuccessModal = null;

    this.verifyCodeModal = null;

    //#region generic
    this.getModalController = function () {
        return this.modalController;
    };
    this.getAlertModal = function () {
        this.alertModal = new AlertModalController();
        this.modalController.setAlertModal(this.alertModal);
        return this.alertModal;
    };
    this.getBadgeAlertModal = function () {
        this.badgeAlertModal = new BadgeAlertModalController();
        this.modalController.setBadgeAlertModal(this.badgeAlertModal);
        return this.badgeAlertModal;
    };
    this.getConfirmModal = function () {
        this.confirmModal = new ConfirmModalController();
        this.modalController.setConfirmModal(this.confirmModal);
        return this.confirmModal;
    };
    this.getLoadingModal = function () {
        this.loadingModal = new LoadingModalController();
        this.modalController.setLoadingModal(this.loadingModal);
        return this.loadingModal;
    };
    //#endregion generic
    //#region authen
    this.getPdpaModal = function () {
        this.pdpaModal = new PdpaModalController();

        if (this.alertModal) {
            this.pdpaModal.setAlertModal(this.alertModal);
        }

        this.modalController.setPdpaModal(this.pdpaModal);
        return this.pdpaModal;
    };
    //#endregion authen
    //#region redeem
    this.getConfirmRedeemModal = function () {
        this.confirmRedeemModal = new ConfirmRedeemModalController();
        this.modalController.setConfirmRedeemModal(this.confirmRedeemModal);
        return this.confirmRedeemModal;
    };
    this.getSerialModal = function () {
        this.serialModal = new SerialModalController();
        this.modalController.setSerialModal(this.serialModal);
        return this.serialModal;
    };
    this.getDrawDeliveryModal = function () {
        this.drawDeliveryModal = new DrawDeliveryModalController();
        this.modalController.setDrawDeliveryModal(this.drawDeliveryModal);
        return this.drawDeliveryModal;
    };
    this.getShippingAddressModal = function () {
        this.shippingAddressModal = new ShippingAddressModalController();
        this.modalController.setShippingAddressModal(this.shippingAddressModal);
        return this.shippingAddressModal;
    };
    this.getShareModal = function () {
        this.shareModal = new ShareModalController();
        this.modalController.setShareModal(this.shareModal);
        return this.shareModal;
    }
    //#endregion redeem

    //#region address
    this.getAddAddressModal = function () {
        this.addAddressModal = new AddAddressModalController();

        if (this.alertModal) {
            this.addAddressModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.addAddressModal.setLoadingModal(this.loadingModal);
        }

        this.modalController.setAddAddressModal(this.addAddressModal);
        return this.addAddressModal;
    };
    this.getEditAddressModal = function () {
        this.editAddressModal = new EditAddressModalController();

        if (this.alertModal) {
            this.editAddressModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.editAddressModal.setLoadingModal(this.loadingModal);
        }

        this.modalController.setEditAddressModal(this.editAddressModal);
        return this.editAddressModal;
    };
    this.getListAddressModal = function () {
        this.listAddressModal = new ListAddressModalController();

        if (this.alertModal) {
            this.listAddressModal.setAlertModal(this.alertModal);
        }
        if (this.confirmModal) {
            this.listAddressModal.setConfirmModal(this.confirmModal);
        }
        if (this.loadingModal) {
            this.listAddressModal.setLoadingModal(this.loadingModal);
        }
        this.listAddressModal.setAddAddressModal(this.addAddressModal);
        this.listAddressModal.setEditAddressModal(this.editAddressModal);

        this.modalController.setListAddressModal(this.listAddressModal);
        return this.listAddressModal;
    };
    this.getAddTaxAddressModal = function () {
        this.addTaxAddressModal = new AddTaxAddressModalController();

        if (this.alertModal) {
            this.addTaxAddressModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.addTaxAddressModal.setLoadingModal(this.loadingModal);
        }

        this.modalController.setAddTaxAddressModal(this.addTaxAddressModal);
        return this.addTaxAddressModal;
    };
    this.getEditTaxAddressModal = function () {
        this.editTaxAddressModal = new EditTaxAddressModalController();

        if (this.alertModal) {
            this.editTaxAddressModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.editTaxAddressModal.setLoadingModal(this.loadingModal);
        }

        this.modalController.setEditTaxAddressModal(this.editTaxAddressModal);
        return this.editTaxAddressModal;
    };
    this.getListTaxAddressModal = function () {
        this.listTaxAddressModal = new ListTaxAddressModalController();

        if (this.alertModal) {
            this.listTaxAddressModal.setAlertModal(this.alertModal);
        }
        if (this.confirmModal) {
            this.listTaxAddressModal.setConfirmModal(this.confirmModal);
        }
        if (this.loadingModal) {
            this.listTaxAddressModal.setLoadingModal(this.loadingModal);
        }
        this.listTaxAddressModal.setAddAddressModal(this.addTaxAddressModal);
        this.listTaxAddressModal.setEditAddressModal(this.editTaxAddressModal);

        this.modalController.setListTaxAddressModal(this.listTaxAddressModal);
        return this.listTaxAddressModal;
    };
    //#endregion address
    //#endregion pdpa
    this.getCancelTermsAndPrivacyModal = function () {
        this.cancelTermsAndPrivacyModal = new CancelTermsAndPrivacyModalController();
        this.modalController.setCancelTermsAndPrivacyModal(this.cancelTermsAndPrivacyModal);
        return this.cancelTermsAndPrivacyModal;
    };
    //#endregion pdpa
    // #region profile
    this.getChangeMobileNumberModal = function () {
        this.changeMobileNumberModal = new ChangeMobileNumberModalController();
        this.modalController.setChangeMobileNumberModal(this.changeMobileNumberModal);
        return this.changeMobileNumberModal;
    };
    // #endregion profile
    this.getFlashSaleModal = function () {
        this.flashSaleModal = new FlashsaleModalController();
        this.modalController.setFlashSaleModal(this.flashSaleModal);
        return this.flashSaleModal;
    };

    this.getConfirmSurpriseModal = function () {
        this.confirmSurpriseModal = new ConfirmSurpriseModalController();
        this.modalController.setConfirmSurpriseModal(this.confirmSurpriseModal);
        return this.confirmSurpriseModal;
    };
    this.getAlertConditionModal = function () {
        this.alertConditionModal = new AlertConditionModalController();
        this.modalController.setAlertConditionModal(this.alertConditionModal);
        return this.alertConditionModal;
    };

    this.getFGFModal = function () {
        this.fgfModal = new FGFModalController();
        this.modalController.setFGFModal(this.fgfModal);
        return this.fgfModal;
    };
    this.getShareFGFModal = function () {
        this.sharefgfModal = new FGFShareModalController();
        this.modalController.setShareFGFModal(this.sharefgfModal);
        return this.sharefgfModal;
    };
    this.getPromocodeModal = function () {
        this.promocodeModal = new PromocodeModalController();
        this.modalController.setPromocodeModal(this.promocodeModal);
        return this.promocodeModal;
    };
    this.getPromocodeSuccessModal = function () {
        this.promocodeSuccessModal = new PromocodeSuccessModalController();
        this.modalController.setPromocodeSuccessModal(this.promocodeSuccessModal);
        return this.promocodeSuccessModal;
    };
    this.getVerifyCodeModal = function () {
        this.verifyCodeModal = new VerifyCodeModalController();
        this.modalController.setVerifyCodeModal(this.verifyCodeModal);
        return this.verifyCodeModal;
    };
}
